export const PLATFORM_API_URL = '/_api/communities-blog-api-web';
